













import {Vue, Component, Prop} from "vue-property-decorator";
import CommentDisplay from "@/components/CommentDisplay.vue";
import { CommentPost } from "./CommentForm.vue";
import { User } from "../services/auth.service";

@Component({
    components: {
        CommentDisplay,
    }
})
export default class Comments extends Vue {
    @Prop()
    public comments!: Comment[];

    @Prop()
    public post!: CommentPost;

    @Prop()
    public user!: User;


}
